<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4">
        <h2 class="h h--2 h--dark">Historia faktur</h2>
        <p class="paragraph">
          Historia faktur daje wgląd we wszystkie faktury, które dodałeś jako
          dowód zakupu
        </p>
        <p class="paragraph--green">
          Zarejestrowana kwota:
          <strong
            >{{
              parseFloat(user.total_sale).toFixed(2).replace(".", ",")
            }}
            PLN</strong
          ><br />
        </p>
        <p class="paragraph">
          <router-link :to="{ name: 'InvoicesAdd' }" class="">
            Dodaj dowód zakupu &raquo;
          </router-link>
        </p>
      </div>
      <div class="col-lg-8" v-bind:class="{ pending: pagination.pending }">
        <div class="profile" v-if="invoices.length == 0">
          <p>brak faktur</p>
        </div>
        <div v-else>
          <table class="invoices__table">
            <tr>
              <th colspan="6" class="with-table-td">
                <table>
                  <tr>
                    <th width="60">ID</th>
                    <th width="110">data dodania</th>
                    <th width="110">profil zgłoszenia</th>
                    <th width="94">kwota netto</th>
                    <th width="94">liczba punktów</th>
                    <!-- <th width="94">Twoje złotówki</th> -->
                    <th class="text-right">status</th>
                  </tr>
                </table>
              </th>
              <th width="40"></th>
            </tr>
            <tr v-for="(inv, index) in invoices" :key="index">
              <td colspan="6" class="with-table-td">
                <table>
                  <tr>
                    <td width="60">{{ inv.id }}</td>
                    <td width="110">
                      {{ inv.created_at | formatDate("DD.MM.YYYY") }}
                    </td>
                    <td width="110">
                      <span v-if="inv.invoice_type == 1">
                        <span v-for="(contest, cin) in inv.contests" :key="cin">
                          {{ contest.name
                          }}<span v-if="cin < inv.contests.length - 1">,</span>
                        </span>
                      </span>
                      <span v-else-if="inv.invoice_type == 2">
                        Umowa
                        <span
                          v-for="(saleContract, cin) in inv.sale_contracts"
                          :key="cin"
                        >
                          #{{ saleContract.id }} "{{ saleContract.title }}"
                        </span>
                      </span>
                      <span v-else> - brak - </span>
                    </td>
                    <td width="94">
                      {{ inv.invoice_printed_value.replace(".", ",") }}
                    </td>
                    <td width="94">
                      <span v-if="inv.invoice_type == 1">
                        {{
                          !inv.predicted_points
                            ? 0
                            : inv.predicted_points.toFixed(3).replace(".", ",")
                        }}
                      </span>
                      <span v-else> - </span>
                    </td>
                    <!-- <td width="94">{{ !inv.amount ? 0 : inv.amount }}</td> -->
                    <td>
                      <span
                        class="invoices__status"
                        :class="'invoices__status--' + inv.status.id"
                        >{{ inv.status.name }}</span
                      >
                    </td>
                  </tr>
                  <tr v-if="inv.visible">
                    <td class="desc-td" colspan="7">
                      <div
                        v-if="
                          inv.additional_info && inv.additional_info != 'null'
                        "
                      >
                        <h4 class="invoices__heading">Uwagi:</h4>
                        <p>{{ inv.additional_info }}</p>
                      </div>
                      <div
                        class="invoices__admin-notes"
                        v-if="inv.notes.length > 0"
                      >
                        <h4 class="invoices__heading">Uwagi administratora:</h4>
                        <div
                          v-for="(note, index) in inv.notes"
                          v-bind:key="index"
                          class="invoices__admin-note"
                        >
                          <p class="invoices__admin-note-date">
                            {{ note.created_at }}
                          </p>
                          <div v-html="note.content"></div>
                        </div>
                      </div>
                      <p v-if="!inv.additional_info">Brak uwag</p>
                      <div v-if="inv.photos.length > 0">
                        <h4 class="invoices__heading">Dowody zakupu:</h4>
                        <img
                          v-auth-image="
                            '/photos/' + photo.id + '?thumbnail=150'
                          "
                          class="invoices__thumb"
                          v-for="(photo, index) in inv.photos"
                          :key="index"
                          @click="showImg(photo.id)"
                        />
                      </div>
                      <div v-if="inv.documents.length > 0">
                        <h4 class="invoices__heading">Dowody zakupu:</h4>

                        <div
                          class="card p-3 d-inline-block"
                          style="width: 140px"
                          v-for="(doc, index) in inv.documents"
                          :key="index"
                        >
                          <a
                            href=""
                            @click.prevent.stop="
                              download(doc.id, doc.original_filename)
                            "
                          >
                            <img
                              :alt="doc.original_filename"
                              :title="doc.original_filename"
                              src="data:image/png;base64,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"
                              height="100"
                              width="100"
                            />
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
              <td class="va-top">
                <a href="" @click.prevent="toggleDesc(inv)">
                  <img
                    src="../../../assets/img/arrows_down.png"
                    alt=""
                    v-if="!inv.visible"
                  />
                  <img
                    src="../../../assets/img/arrows_up.png"
                    alt=""
                    v-if="inv.visible"
                  />
                </a>
              </td>
            </tr>
          </table>
          <pagination
            class="pagination-wraper"
            v-model="pagination.current_page"
            :page="pagination.current_page"
            :per-page="parseInt(pagination.per_page)"
            :records="pagination.total"
            @paginate="onChangePaginate"
            v-if="pagination && pagination.last_page > 1"
          ></pagination>
        </div>
      </div>
    </div>
    <page-box-set-widget></page-box-set-widget>
    <div class="overlay" v-if="selected_photo">
      <img
        src="../../../assets/img/close.png"
        alt=""
        class="overlay__close"
        @click="closeImg()"
      />
      <div
        class="overlay__container d-flex justify-content-center align-items-center"
      >
        <img v-auth-image="'/photos/' + selected_photo" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "InvoicesComponent",
  data() {
    return {
      invoices: [],
      pagination: {},
      image: "",
      selected_photo: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
      method: "get",
      url: "/invoices",
    })
      .then((notificationsReponse) => {
        var invoices = notificationsReponse.data.data.invoices;
        for (var inv in invoices) {
          invoices[inv].visible = false;
        }
        next((vm) => {
          vm.invoices = invoices;
          vm.pagination = notificationsReponse.data.pagination;
        });
      })
      .catch((error) => next(false));
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  mounted: function () {
    if (!this.user || this.user.id != 1) {
      this.$gtag.pageview({
        page_path: "/faktury",
      });
    }
  },
  methods: {
    toggleDesc: function (inv) {
      inv.visible = !inv.visible;
    },

    /**
     * On change paginate event.
     *
     * @param  {int} page
     * @return void
     */
    onChangePaginate(page) {
      let vm = this;

      vm.pagination.pending = true;

      Vue.axios({
        method: "get",
        url: "/invoices",
        params: {
          page: page,
        },
      })
        .then((response) => {
          var invoices = response.data.data.invoices;
          for (var inv in invoices) invoices[inv].visible = false;

          vm.invoices = invoices;
          vm.pagination = response.data.pagination;
          vm.pagination.pending = false;
        })
        .catch((error) => (vm.pagination.pending = false));
    },
    showImg: function (image_id) {
      this.selected_photo = image_id;
    },
    closeImg: function () {
      this.selected_photo = null;
    },
    download: function (document_id, file_name) {
      var _this = this;
      Vue.axios({
        method: "get",
        url: "invoices/" + document_id + "/download",
        params: {},
        responseType: "blob",
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));

          var fileLink = document.createElement("a");

          fileLink.href = fileURL;

          fileLink.setAttribute("download", file_name + ".pdf");

          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/app/home/invoices/InvoicesComponent.vue